<template>
  <div>
    <Yukleniyor :data="lo"></Yukleniyor>
    <el-alert
      title="Banka Kaydı Yok"
      type="success"
      :closable="false"
      v-if="!Liste && !lo">
    </el-alert>
    <el-table
      class="table-xs"
      :data="Liste"
      v-if="Liste && !lo"
      row-key="id"
      :height="Height"
      show-summary
      :summary-method="TableFooter">
      <el-table-column
        label="İşlem Tarihi"
        prop="Tarih"
        width="120"
      >
      </el-table-column>
      <el-table-column
        label="Makbuz No"
        prop="mNo"
        width="100">
      </el-table-column>
      <el-table-column
        label="Açıklama"
        prop="Aciklama">
      </el-table-column>
      <el-table-column
        label="Tutar"
        prop="Tutar"
        align="right"
        width="90">
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
  import Yukleniyor from "../../../../Doc/Yukleniyor";

  export default {
    components: {Yukleniyor},
    props: ["Kisi_id"],
    data() {
      return {
        lo: true,
        Liste: null,
        AltToplam: 0,
        Height: window.innerHeight - 215
      }
    },
    methods: {
      TableFooter() {
        const sums = [];
        sums[3] = this.AltToplam;
        return sums;
      },
      SayfaYukle() {
        if (this.Kisi_id) {
          this.$store.dispatch("Get", {path: 'yonetim/kisi/ekran/' + this.Kisi_id + '/banka'})
            .then(response => {
              if (response.Durum === 'OK') {
                this.Liste = response.Liste;
                this.AltToplam = response.AltToplam;
                this.lo = false;
              } else {
                this.$message.error(response.Mesaj);
                this.hata = response.Hata;
              }
            });

        }


      },

    },
    created() {
      this.SayfaYukle()
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Yonetim/kisi/Ekran/KisiBanka.vue